<template>
  <layout-default-app-bar :back-to="true">
    {{ titulo }}
  </layout-default-app-bar>
</template>

<script>
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';
import db from '@/plugins/dexie';

export default {
  name: 'ViewImpressaoPedidoAppBar',

  data() {
    return {
      titulo: 'Impressao Pedido',
    };
  },

  components: {
    LayoutDefaultAppBar,
  },

  async mounted() {
    const idPedido = this.$route.query.id;

    if (idPedido) {
      try {
        let pedido = await db.pedido.where('idpedido').equals(parseInt(idPedido)).first();
        
        if (!pedido) {
          pedido = await db.pedido.where('idpedido').equals(String(idPedido)).first();
        }

        if (pedido && pedido.orcamento == 1) {
          this.titulo = 'Impressao Orçamento';
        }
      } catch (error) {
        console.error("Erro ao verificar tipo de pedido no AppBar:", error);
      }
    }
  }
};
</script>